import axios from "../http-client/axios";
import { GORIJA_URL } from "../urls/base-urls";
//const GORIJA_URL = 'http://localhost:8298'

export async function getGratifications(competenceYear) {
  const resp = await axios({
    url: `${GORIJA_URL}/gratifications`,
    method: "post",
    data: { anoCompetencia: competenceYear },
    headers: {
      "content-type": "application/json",
      //"crm" :""
    },
  });

  // const resp = await axios({
  //   url: 'http://dev-core-api.unimedflorianopolis.com.br/cooperado/tst/api/NotaFiscalXml/ConsultarBonificacao',
  //   method: "post",
  //   data: { AnoCompetencia: competenceYear, CodigoBonificado: 1515 },
  // });

  const returnData = resp.data.map((item, index) => ({
    ...item,
    Index: index,
    CanSendInvoice: item.EnviarNota === "S",
    InvoiceAlreadySent: item.DataEnvio != "",
    IsTransfer: item.Tipo == "REPASSE",
  }));

  return returnData;
}

export async function sendFiles(formData) {
  let notaFiscalBonificacaoRequest = {    
    anoCompetencia: 2025,
    sistema: "PortalCooperado",    
    numDemonstrativoPgto: formData.numeroDemonstrativo,
  };

  let formRequest = new FormData();

  const blob = new Blob([JSON.stringify(notaFiscalBonificacaoRequest)],{
    type: 'application/json'
  });
  formRequest.append("jsonData", blob);
  //formRequest.append("jsonData", JSON.stringify(notaFiscalBonificacaoRequest));
  formRequest.append("files", formData.filePdf);
  formRequest.append("files", formData.fileXml);

  console.log("sendFiles|formRequest: ", formRequest);

  const resp = await axios({
    //url: `http://localhost:8298/integrate-gratification`,
    url: `${GORIJA_URL}/integrate-gratification`,
    //url: "https://dev-core-api.unimedflorianopolis.com.br/cooperado/tst/api/NotaFiscalXml/IntegrarBonificacao",

    method: "post",
    //headers: { crm: 1515 },
    data: formRequest,
  });

  //FAKE
  // const resp = await new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve({
  //       status: 200,
  //       data: { NumeroNota: '123456' },
  //     });
  //   }, 2000);
  // });

  return resp.data;
}

export async function getGratificationPdf(year, demonstrative) {
  const resp = await axios({
    url: `${GORIJA_URL}/gratifications/pdf/${year}/${demonstrative}`,
    //url: `http://localhost:8298/gratifications/pdf/${year}/${demonstrative}`,
    //url: `http://dev-core-api.unimedflorianopolis.com.br/cooperado/tst/api/analitica/bonificacao/pdf/1515/${year}/${demonstrative}`,
    method: "get",
    //headers: { crm: 1515 },
    headers: { "content-type": "application/json" },
  });

  return resp.data.fileBase64;
}
